import { useLayoutEffect, useRef, useState } from 'react';

export const useHasMenuToggled = (open: boolean): boolean => {
   const [hasToggled, setHasToggled] = useState(false);
   const previousOpenRef = useRef(open);

   useLayoutEffect(() => {
      if (previousOpenRef.current !== open) {
         previousOpenRef.current = open;
         setHasToggled(true);
      }
   }, [open]);

   return hasToggled;
};
